module.exports = __webpack_public_path__ + "img/s3Model3.5b7af8c8.webp";